import { render, staticRenderFns } from "./TableMorbidity.vue?vue&type=template&id=200bf777"
import script from "./TableMorbidity.vue?vue&type=script&lang=js"
export * from "./TableMorbidity.vue?vue&type=script&lang=js"
import style0 from "./TableMorbidity.vue?vue&type=style&index=0&id=200bf777&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports